/* eslint-disable max-classes-per-file */
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {
  FormControlName,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import { Utils } from '@app/shared/helpers/utils';
import { fromEvent, merge, of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  CustomValidators,
  FormServiceValidationMessages,
  Pattern,
  TokenService,
  UserService
} from 'viggo-sistemas-core-web';
import {
  validateCnpj,
  validateCpf
} from '../../../../shared/utils/validators_cpf_cnpj';
import { ISupervisor } from '../../../supervisor/model/supervisor.model';
import { SupervisorService } from '../../../supervisor/services/supervisor-service/supervisor.service';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';

@Component({
  selector: 'app-fast-supervisor',
  templateUrl: './fast-supervisor.component.html',
  styleUrls: ['./fast-supervisor.component.scss'],
  providers: [ParceiroService, SupervisorService, UserService]
})
export class FastSupervisorComponent implements OnInit {
  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;
  user_id: string;

  /**
   * Lugar onde as mensagens de erro serão escritas
   */
  public displayMessage = {};
  /**
   * Service para gerar as menagens de erro
   */
  protected formServiceValidationMessages: FormServiceValidationMessages;
  /**
   * Ref para os itens de input que estão na view
   */
  @ViewChildren(FormControlName, { read: ElementRef }) inputs: QueryList<
    ElementRef<HTMLInputElement>
  >;

  viewInit = false;

  findParceiro = false;

  entity: ISupervisor = {
    parceiro: {
      contatos: [],
      enderecos: []
    } as IParceiro
  } as ISupervisor;

  constructor(
    public dialogRef: MatDialogRef<FastSupervisorComponent>,
    public supervisorService: SupervisorService,
    public tokenService: TokenService,
    public parceiroService: ParceiroService,
    public userService: UserService,
    public snackBar: MatSnackBar,
    private fb: UntypedFormBuilder
  ) {
    this.formServiceValidationMessages = new FormServiceValidationMessages({
      nome_razao_social: {
        required: 'O nome é requerido.',
        maxlength: 'O nome deve ter no maximo 60 caracteres.',
        isEmptyValue: 'Valor inválido: remova os espaços!'
      },
      apelido_nome_fantasia: {
        maxlength: 'Este nome é muito longo.',
        minlength: 'Este nome é muito curto.',
        isEmptyValue: 'Valor inválido: remova os espaços!'
      },
      cpf_cnpj: {
        repeated: 'Informação já cadastrada.',
        mask: 'Valor inválido.',
        required: 'O CPF/CNPJ é obrigatório',
        pattern: 'Este CPF/CNPJ é inválido.',
        maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
        duplicate: 'O CPF/CNPJ já esta cadastrado',
        validateCPF: 'Este CPF é inválido.',
        validateCNPJ: 'Este CNPJ é inválido.'
      },
      rg_insc_est: {
        pattern: 'Este valor é inválido.',
        maxlength: 'O campo deve conter no máximo 20 caracteres.',
        existSpecialChar: 'Valor inválido, não aceita pontuação!',
        isEmptyValue: 'Valor inválido: remova os espaços!'
      }
    });
  }

  ngOnInit(): void {
    const today = new Date();
    this.form = this.fb.group({
      nome_razao_social: [
        this.entity.parceiro.nome_razao_social,
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      apelido_nome_fantasia: [
        this.entity.parceiro.apelido_nome_fantasia,
        [
          Validators.minLength(1),
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      cpf_cnpj: [this.entity.parceiro.cpf_cnpj, [Validators.required]],
      rg_insc_est: [
        this.entity.parceiro.rg_insc_est,
        [
          Validators.pattern(Pattern.patternInscEstadual()),
          Validators.maxLength(20),
          CustomValidators.existSpecialChar(),
          CustomValidators.isEmptyValue()
        ]
      ],
      data_nascimento: [
        this.entity.data_nascimento,
        [CustomValidators.date(today), CustomValidators.isEmptyValue()]
      ],
      user: [
        null,
        [CustomValidators.typeIs('object'), CustomValidators.isEmptyValue()]
      ]
    });
    this.user_id = this.form.value.user ? this.form.value.user.id : undefined;
    this.form.controls.cpf_cnpj.valueChanges.subscribe(() => {
      this.validar();
    });
  }
  validar() {
    let cpfCnpjValue = this.form.controls.cpf_cnpj.value;
    if (cpfCnpjValue.toString().length <= 11) {
      if (validateCpf(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
        this.form.updateValueAndValidity();
      }
    } else {
      if (validateCnpj(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
        this.form.updateValueAndValidity();
      }
    }
  }
  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.form.invalid) this.form.markAllAsTouched();
    return this.viewInit && this.form.invalid;
  }

  get formValid(): boolean {
    return this.viewInit && this._fastEndereco.form.valid && this.form.valid;
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  public checkRgInscEstadual(): void {
    const rgInsc = this.form.controls.rg_insc_est;

    if (
      rgInsc.value === null ||
      rgInsc.invalid ||
      rgInsc.value === '' ||
      this.findParceiro
    )
      return;
    const rgInscValue: string = rgInsc.value.replace(/[^a-zA-Z0-9 ]/g, '');

    this.parceiroService
      .getEntitiesByParams(
        `rg_insc_est=${rgInscValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe((parceiro: IParceiro) => {
        if (parceiro[0] && parceiro[0].id) {
          this.form.controls.rg_insc_est.setErrors({ duplicate: true });
          this.form.updateValueAndValidity();
          return {} as IParceiro;
        }
      });
  }

  public checkCpfCnpj(): void {
    const cpfCnpj = this.form.controls.cpf_cnpj;

    if (cpfCnpj.invalid) return;
    const cpfCnpjValue: string = cpfCnpj.value;

    this.parceiroService
      .getEntitiesByParams(
        `cpf_cnpj=${cpfCnpjValue}`,
        this.tokenService.getDomain().id
      )
      .pipe(
        map(parceiros => {
          if (parceiros.length) {
            this.findParceiro = true;
            return { ...parceiros[0], cpf_cnpj: parceiros[0].cpf_cnpj.trim() };
          } else {
            this.findParceiro = false;
            return {} as IParceiro;
          }
        }),
        mergeMap(parceiro => {
          if (parceiro === undefined) return of(parceiro);
          return this.supervisorService.getEntity(parceiro.id).pipe(
            map(ent => {
              if (ent && ent.id) {
                this.form.controls.cpf_cnpj.setErrors({ duplicate: true });
                this.form.updateValueAndValidity();
                return {} as IParceiro;
              }
              return parceiro;
            }),
            catchError(() => of(parceiro))
          );
        })
      )
      .subscribe((parceiro: IParceiro) => {
        if (parceiro === undefined) return;
        else if (Object.keys(parceiro).length !== 0) {
          this.setInformacoesParceiro(parceiro);
          this.form.patchValue({
            apelido_nome_fantasia: parceiro.apelido_nome_fantasia || null,
            nome_razao_social: parceiro.nome_razao_social || null,
            rg_insc_est: parceiro.rg_insc_est || null,
            data_nascimento: null
          });
        }
      });
  }

  onSubmit(): void {
    var entity: ISupervisor | any = Utils.clearObject<ISupervisor>({
      ...this.entity,
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this.form.value,
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues(),
        user_id: undefined,
        data_nascimento: undefined
      }),
      data_nascimento: this.form.value.data_nascimento,
      user_id: this.form.value.user ? this.form.value.user.id : null
    } as ISupervisor);
    delete entity.parceiro.user;
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    this.insert(entity);
  }

  insert(entity: ISupervisor): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.supervisorService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, supervisor]) => {
            return this.supervisorService.getEntity(supervisor.id, [
              'parceiro'
            ]);
          })
        )
        .subscribe(
          supervisor => {
            this.snackBar.open('Supervisor criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(supervisor);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.supervisorService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(supervisor => {
            return this.supervisorService.getEntity(supervisor.id, [
              'parceiro'
            ]);
          })
        )
        .subscribe(
          supervisor => {
            this.snackBar.open('Supervisor criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(supervisor);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }
  /**
   * @lifeCycle
   */
  public ngAfterViewInit(): void {
    this.viewInit = true;
    const observers = this.inputs.map(el =>
      fromEvent(el.nativeElement, 'blur')
    );

    merge(...observers, this.form.valueChanges).subscribe(() => {
      if (this.form.invalid)
        this.displayMessage = this.formServiceValidationMessages.getMessagesForm(
          this.form
        );
    });
  }
}
